import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Container from '@/components/ui/container'
import Link from '@/components/ui/link'
import logoWhite from '@/assets/images/logo-white.png'
import { getPath, navigate } from '@/lib/navigation'

const practiceHrefs = ['/roadmap', '/roadmap', '/roadmap', '/']

function scrollToPlatform() {
  const tryScroll = (attempts = 0) => {
    const el = document.getElementById('platform')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    } else if (attempts < 20) {
      setTimeout(() => tryScroll(attempts + 1), 50)
    }
  }
  tryScroll()
}

const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/bravic-global',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/bravic.global/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
        <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.88 0 1.441 1.441 0 012.88 0z" />
      </svg>
    ),
  },
  // {
  //   name: 'X',
  //   href: '#',
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
  //       <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  //     </svg>
  //   ),
  // },
  // {
  //   name: 'Facebook',
  //   href: '#',
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
  //       <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  //     </svg>
  //   ),
  // },
]

export default function Footer() {
  const { t } = useTranslation()

  const practiceAreas = t('footer.practiceAreas', { returnObjects: true }) as string[]
  const institutionalLinks = t('footer.institutionalLinks', { returnObjects: true }) as string[]
  const offices = t('footer.offices', { returnObjects: true }) as string[]

  useEffect(() => {
    if (getPath() === '/' && sessionStorage.getItem('scrollToPlatform')) {
      sessionStorage.removeItem('scrollToPlatform')
      scrollToPlatform()
    }
  }, [])

  const handlePlatformClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (getPath() === '/') {
      scrollToPlatform()
    } else {
      sessionStorage.setItem('scrollToPlatform', '1')
      navigate('/')
    }
  }

  return (
    <footer className="bg-surface-container-lowest w-full pt-12 md:pt-16 lg:pt-24 pb-8 md:pb-12 border-t border-on-surface-variant/15">
      <Container>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 font-body text-on-surface-variant text-sm leading-relaxed">
          <div>
            <img src={logoWhite} alt="Bravic" className="h-8 mb-4" />
            <p className="mb-6 opacity-70">{t('footer.description')}</p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  aria-label={social.name}
                  className="text-on-surface-variant hover:text-primary transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h5 className="text-primary font-bold uppercase tracking-widest text-[0.65rem] mb-2">
              {t('footer.deliveryLayers')}
            </h5>
            {practiceAreas.map((area, i) => {
              const isPlatform = i === 3
              const href = practiceHrefs[i] ?? '/'
              return (
                <Link
                  key={area}
                  href={href}
                  onClick={isPlatform ? handlePlatformClick : undefined}
                  className="hover:text-primary transition-colors"
                >
                  {area}
                </Link>
              )
            })}
          </div>

          <div className="flex flex-col gap-4">
            <h5 className="text-primary font-bold uppercase tracking-widest text-[0.65rem] mb-2">
              {t('footer.institutional')}
            </h5>
            {institutionalLinks.map((item, i) => {
              const href = i === 0 ? '/manifesto' : i === 1 ? '/privacy' : '/terms'
              return (
                <Link key={item} href={href} className="hover:text-primary transition-colors">
                  {item}
                </Link>
              )
            })}
          </div>

          <div className="flex flex-col gap-4">
            <h5 className="text-primary font-bold uppercase tracking-widest text-[0.65rem] mb-2">
              {t('footer.globalHq')}
            </h5>
            <p className="opacity-70">
              {t('footer.address.line1')}
              <br />
              {t('footer.address.line2')}
            </p>
            <p className="opacity-70">
              {t('footer.address.phone')}
              <br />
              {t('footer.address.email')}
            </p>
          </div>
        </div>
      </Container>

      <Container className="mt-8 md:mt-12 lg:mt-16 mb-8 text-center">
        <p className="text-on-surface-variant/60 font-display text-lg italic tracking-wide">
          {t('footer.manifesto')}
        </p>
      </Container>

      <Container className="flex flex-col md:flex-row justify-between items-center border-t border-outline-variant/10 pt-8 opacity-50">
        <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        <div className="flex flex-wrap gap-4 sm:gap-6 md:gap-8 mt-4 md:mt-0">
          {offices.map((city) => (
            <span key={city} className="uppercase tracking-widest text-[0.6rem]">
              {city}
            </span>
          ))}
        </div>
      </Container>
    </footer>
  )
}
